module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-7.0b078147.png";